(() => {
  const labels = document.getElementById('sg-art-experience-copy');
  if (!labels) return;
  const copy = JSON.parse(labels.textContent);
  const mobile = window.matchMedia('(max-width: 767px)');
  const hub = document.querySelector('.sg-heroart');
  if (hub && document.getElementById('collection-main')) {
    const view = document.createElement('a');
    view.className = 'sg-art-view';
    view.href = '#collection-main';
    view.textContent = copy.view;
    const browse = hub.querySelector('.sg-hero2__browse');
    if (browse) browse.before(view);
  }
  const hero = document.getElementById('scHF');
  if (!hero) return;
  const title = hero.querySelector('.scHF__h1');
  const price = hero.querySelector('.scHF__price');
  if (title && price) title.after(price);
  const description = hero.querySelector('.scHF__sub');
  let details;
  if (description) {
    details = document.createElement('details');
    details.className = 'sg-art-details';
    const summary = document.createElement('summary');
    summary.textContent = copy.more;
    description.before(details);
    details.append(summary, description);
  }
  const icons = document.getElementById('sg-art-payment-icons');
  const payments = hero.querySelector('.scHF__pays');
  if (payments && icons) payments.replaceChildren(icons.content.cloneNode(true));
  const buy = hero.querySelector('.scHF__add');
  const setDetails = () => { if (details) details.open = !mobile.matches; };
  setDetails();
  mobile.addEventListener('change', setDetails);
  if (!buy || !price || !title) return;
  const dock = document.createElement('div');
  dock.className = 'sg-art-price-dock';
  dock.hidden = true;
  const amount = document.createElement('strong');
  const action = document.createElement('button');
  action.type = 'button';
  action.textContent = copy.buy;
  action.addEventListener('click', () => title.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start'}));
  dock.append(amount, action);
  document.body.append(dock);
  let pending = false;
  const update = () => {
    pending = false;
    const rect = buy.getBoundingClientRect();
    const overlay = document.querySelector('.scHF__lb:not([hidden]), #modal-cart[aria-hidden="false"], #modal-main-menu[aria-hidden="false"]');
    dock.hidden = !mobile.matches || !!overlay || (rect.top >= 0 && rect.bottom <= innerHeight);
    amount.textContent = price.textContent.trim();
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('click', schedule);
  mobile.addEventListener('change', schedule);
  update();
})();
